import { lazy } from "react";

export function lazyWithPreload(factory, maxRetries = 3) {
    const factoryWithRetry = (retriesLeft = maxRetries) => {
        return factory().catch(error => {
            // Check if this is a chunk loading error
            if (error.name === 'ChunkLoadError' || (error.message && error.message.includes('Loading chunk'))) {
                if (retriesLeft > 0) {
                    console.warn(`Chunk load failed, retrying... (${retriesLeft} attempts left)`, error);
                    // Wait a bit before retrying (exponential backoff)
                    const delay = (maxRetries - retriesLeft + 1) * 1000;
                    return new Promise(resolve => setTimeout(resolve, delay))
                        .then(() => factoryWithRetry(retriesLeft - 1));
                } else {
                    // All retries exhausted, force page reload
                    console.error('Chunk load failed after all retries, reloading page...', error);
                    window.location.reload();
                    // Return a promise that never resolves to prevent error from propagating
                    return new Promise(() => {});
                }
            }
            // If it's not a chunk loading error, just throw it
            throw error;
        });
    };

    const Component = lazy(factoryWithRetry);
    Component.preload = factoryWithRetry;
    return Component;
}
